import { MileagePeriod, PriceCalculation } from '../types/types';

export function getMileageAmountPerPeriod(amount: number, includedAmount: number, period: string, t, unitAbbreviation: string) {
  const isRelative = !(period ===MileagePeriod.total || period === PriceCalculation.Interval)
  const mileagePeriod = isRelative ? t('units.' + period) : ''
  const sign = isRelative ? '/' : ' '

  if (amount === 0) {
    return includedAmount.toString() + unitAbbreviation;
  }

  if (includedAmount === 0) {
    return amount.toString() + unitAbbreviation + sign + mileagePeriod;
  }

  return includedAmount.toString() + unitAbbreviation + ' + ' + amount.toString() + unitAbbreviation + sign + mileagePeriod;
}
